import React from 'react';
import UniversalRouter from 'universal-router/main.js';
import './i18n';
// The list of all application routes where each route contains a URL path string (pattern),
// the list of components to load asynchroneously (chunks), data requirements (GraphQL query),
// and a render() function which shapes the result to be passed into the top-level (App) component.
// For more information visit https://github.com/kriasoft/universal-router
const routes = [
  {
    path: '',
    components: () => [import(/* webpackChunkName: 'home' */ './Home')],
    render: ({ components: [Home] }) => ({
      title: 'Zriba Olia',
      body: <Home />,
    }),
  },

  {
    path: '/Entre',
    components: () => [import(/* webpackChunkName: 'entre' */ './Entre')],
    render: ({ components: [Entre] }) => ({
      title: 'Entrée - Zriba Olia',
      body: <Entre />,
    }),
  },

  {
    path: '/MaisonsHote',
    components: () => [
      import(/* webpackChunkName: 'maisonsHote' */ './MaisonsHote'),
    ],
    render: ({ components: [MaisonsHote] }) => ({
      title: 'Maison d’hôte - Zriba Olia',

      body: <MaisonsHote />,
    }),
  },
  {
    path: '/Mosquee',
    components: () => [import(/* webpackChunkName: 'mosquee' */ './Mosquee')],
    render: ({ components: [Mosquee] }) => ({
      title: 'Mosquée - Zriba Olia',
      body: <Mosquee />,
    }),
  },
  {
    path: '/Paysage',
    components: () => [import(/* webpackChunkName: 'paysage' */ './Paysage')],
    render: ({ components: [Paysage] }) => ({
      title: 'Paysage - Zriba Olia',
      body: <Paysage />,
    }),
  },

  {
    path: '/Maison',
    components: () => [import(/* webpackChunkName: 'Maison' */ './Maison')],
    render: ({ components: [Maison] }) => ({
      title: 'Maison - Zriba Olia',
      body: <Maison />,
    }),
  },

  {
    path: '/Daraelfeija',
    components: () => [import(/* webpackChunkName: 'souk' */ './Daraelfeija')],
    render: ({ components: [Daraelfeija] }) => ({
      title: 'Dar EL Feja - Zriba Olia',
      body: <Daraelfeija />,
    }),
  },

  {
    path: '/Zaouia',
    components: () => [import(/* webpackChunkName: 'Zaouia' */ './Zaouia')],
    render: ({ components: [Zaouia] }) => ({
      title: 'Zaouïa - Zriba Olia',
      body: <Zaouia />,
    }),
  },

  {
    path: '/End',
    components: () => [import(/* webpackChunkName: 'Zaouia' */ './End')],
    render: ({ components: [End] }) => ({
      title: 'End - Zriba Olia',
      body: <End />,
    }),
  },
];

function resolveRoute(ctx) {
  const { route } = ctx;

  if (!route.render) {
    return ctx.next();
  }

  return Promise.all(route.components()).then(components =>
    ctx.render({
      route: route.render({
        components: components.map(x => x.default),
      }),
    }),
  );
}

export default new UniversalRouter(routes, { resolveRoute });



// WEBPACK FOOTER //
// ./src/routes/index.js